import { useCallback } from 'react';
import { CoreDomainSearchStore, DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { useQueryParams } from './useQueryParams';
import { useViewTransition } from './useViewTransition';
import { GatePath } from '../Pages/types';
import { SEARCH_QUERY_PARAMS } from '../constants';
export const useResultsBack = function (_temp) {
  let {
    toGate = false
  } = _temp === void 0 ? {} : _temp;
  const {
    navigateBack,
    navigateTo
  } = useViewTransition();
  const {
    search
  } = useQueryParams();
  return useCallback(() => {
    DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
      ctaClick: 'back_button'
    });
    if (toGate) {
      const params = new URLSearchParams(search);
      SEARCH_QUERY_PARAMS.forEach(param => params.delete(param));
      const nextSearch = params.toString();
      navigateTo(nextSearch ? `${GatePath.GATE}?${nextSearch}` : GatePath.GATE);
    } else {
      navigateBack();
    }
    setTimeout(() => {
      CoreDomainSearchStore.resetStore();
    });
  }, [navigateBack, navigateTo, search, toGate]);
};
//# sourceMappingURL=useResultsBack.js.map